import React, {Component} from "react"
import {Modal} from "react-bootstrap"
import IBox from "./IBox"
import {injectIntl} from 'react-intl'

class FullScreenWarningModal extends Component {
  render() {

    const format = this.props.intl.formatMessage

    return (
      <Modal bsSize="lg"
             show={this.props.show}>

        <Modal.Header>
          <h2>{format({id: 'warning'})}</h2>
        </Modal.Header>

        <Modal.Body className="gray-bg" style={{height: 480}}>

          <IBox>
            <h2>{format({id: 'warning.window.width'})}</h2>
          </IBox>
        </Modal.Body>
      </Modal>
    )
  }
}

export default injectIntl(FullScreenWarningModal)



// WEBPACK FOOTER //
// ./src/components/FullScreenWarningModal.js